import { produce } from 'immer';

import { getProfiles, cleanProfilesList, loginAsProfileUser } from '../actions/profiles';

const initialState = {
  list: [],
  meta: {
    current_page: 1,
    per_page: 10,
  },
  loading: false,
  loadings: {
    loginAsUser: false,
  },
};

const reducer = produce((state = initialState, action) => {
  switch (action.type) {
    // GET USERS LIST
    case getProfiles.types.START:
      state.loading = true;
      return state;

    case getProfiles.types.SUCCESS:
      state.list = action.payload.data;
      state.meta = action.payload.meta;
      state.loading = false;
      return state;

    case getProfiles.types.FAIL:
      state.loading = false;
      return state;

    // CLEAN USERS LIST
    case cleanProfilesList.types.INIT:
      state.list = initialState.list;
      state.meta = initialState.meta;
      return state;

    // LOGIN AS USER
    case loginAsProfileUser.types.START:
      state.loadings.loginAsUser = true;
      return state;
    case loginAsProfileUser.types.SUCCESS:
    case loginAsProfileUser.types.FAIL:
      state.loadings.loginAsUser = false;
      return state;

    default:
      return state;
  }
});

export default reducer;
